var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElegant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128",
    transform: "translate(-325 510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118",
    transform: "translate(325 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    d: "M408.894-508.621a14.11 14.11 0 0 1 10.432 4.292 14.112 14.112 0 0 1 4.294 10.435v67.788a14.691 14.691 0 0 1-3.991 10.47c-2.665 2.864-6.177 4.257-10.736 4.257h-67.784a14.049 14.049 0 0 1-10.436-4.3 14.047 14.047 0 0 1-4.294-10.432v-67.788a14.076 14.076 0 0 1 4.3-10.434 14.074 14.074 0 0 1 10.433-4.293h67.784m0-1.379h-67.787a15.536 15.536 0 0 0-11.409 4.7 15.53 15.53 0 0 0-4.7 11.409v67.788a15.5 15.5 0 0 0 4.7 11.409 15.5 15.5 0 0 0 11.409 4.7h67.784q7.378 0 11.746-4.7A16.162 16.162 0 0 0 425-426.106v-67.788a15.573 15.573 0 0 0-4.7-11.409 15.573 15.573 0 0 0-11.409-4.7z",
    fill: "#ff7557",
    "data-name": "Path 997",
    transform: "translate(-325 510)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127",
    transform: "translate(338.877 -485.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    d: "M434.578-388.121H368a2.762 2.762 0 0 1-2.759-2.759v-45.862A2.762 2.762 0 0 1 368-439.5h66.577a2.762 2.762 0 0 1 2.759 2.759v45.862a2.762 2.762 0 0 1-2.758 2.758zm-66.577-50a1.381 1.381 0 0 0-1.379 1.379v45.862A1.381 1.381 0 0 0 368-389.5h66.577a1.381 1.381 0 0 0 1.379-1.379v-45.862a1.381 1.381 0 0 0-1.379-1.379z",
    fill: "#ff7557",
    "data-name": "Path 998",
    transform: "translate(-365.243 439.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(.842 6.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_451",
    d: "M0 0h70.714v1.379H0z",
    fill: "#ff7557",
    "data-name": "Rectangle 451"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121",
    transform: "translate(9.906 24.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    d: "M513.358-352.325a2.971 2.971 0 0 0 2.884-2.278h-5.768a2.971 2.971 0 0 0 2.884 2.278z",
    fill: "none",
    "data-name": "Path 999",
    transform: "translate(-470.301 359.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    d: "M513.358-365.21a2.971 2.971 0 0 0-2.884 2.278h5.768a2.971 2.971 0 0 0-2.884-2.278z",
    fill: "none",
    "data-name": "Path 1000",
    transform: "translate(-470.301 366.589)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    d: "M432.741-358.6h-38.08a.69.69 0 0 0-.69.69.689.689 0 0 0 .69.69h38.08a4.326 4.326 0 0 1-.06-.69 4.333 4.333 0 0 1 .06-.69z",
    fill: "#ff7557",
    "data-name": "Path 1001",
    transform: "translate(-393.971 362.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    d: "M535.517-358.6h-4.247a4.336 4.336 0 0 1 .06.69 4.329 4.329 0 0 1-.06.69h4.247a.69.69 0 0 0 .69-.69.69.69 0 0 0-.69-.69z",
    fill: "#ff7557",
    "data-name": "Path 1002",
    transform: "translate(-483.926 362.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    d: "M510.691-352.325a2.971 2.971 0 0 1-2.884-2.278h-1.4a4.35 4.35 0 0 0 4.287 3.658 4.35 4.35 0 0 0 4.287-3.658h-1.4a2.971 2.971 0 0 1-2.89 2.278z",
    fill: "#ff7557",
    "data-name": "Path 1003",
    transform: "translate(-467.634 359.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    d: "M510.691-367.831a2.971 2.971 0 0 1 2.884 2.278h1.4a4.351 4.351 0 0 0-4.287-3.658 4.35 4.35 0 0 0-4.287 3.658h1.4a2.971 2.971 0 0 1 2.89-2.278z",
    fill: "#ff7557",
    "data-name": "Path 1004",
    transform: "translate(-467.634 369.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    d: "M507.609-357.913a2.957 2.957 0 0 1 .084-.69h-1.4a4.336 4.336 0 0 0-.06.69 4.329 4.329 0 0 0 .06.69h1.4a2.953 2.953 0 0 1-.084-.69z",
    fill: "#ff7557",
    "data-name": "Path 1005",
    transform: "translate(-467.52 362.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    d: "M528.6-358.6h-1.4a2.957 2.957 0 0 1 .084.69 2.953 2.953 0 0 1-.084.69h1.4a4.329 4.329 0 0 0 .06-.69 4.336 4.336 0 0 0-.06-.69z",
    fill: "#ff7557",
    "data-name": "Path 1006",
    transform: "translate(-481.259 362.261)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122",
    transform: "translate(9.906 13.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    d: "M416.019-397.031a2.97 2.97 0 0 0-2.94 2.583h5.88a2.97 2.97 0 0 0-2.94-2.583z",
    fill: "none",
    "data-name": "Path 1007",
    transform: "translate(-406.49 398.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    d: "M416.3-383.567a2.97 2.97 0 0 0 2.793-1.973h-5.586a2.971 2.971 0 0 0 2.793 1.973z",
    fill: "none",
    "data-name": "Path 1008",
    transform: "translate(-406.769 390.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    d: "M399.172-389.54h-4.511a.689.689 0 0 0-.69.69.69.69 0 0 0 .69.69h4.611a4.32 4.32 0 0 1-.119-.995c0-.13.008-.258.019-.385z",
    fill: "#ff7557",
    "data-name": "Path 1009",
    transform: "translate(-393.971 393.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    d: "M471.7-389.54h-37.734c.011.127.02.255.02.385a4.341 4.341 0 0 1-.119.995H471.7a.69.69 0 0 0 .69-.69.69.69 0 0 0-.69-.69z",
    fill: "#ff7557",
    "data-name": "Path 1010",
    transform: "translate(-420.109 393.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    d: "M413.382-399.652a2.97 2.97 0 0 1 2.94 2.583h1.388a4.351 4.351 0 0 0-4.328-3.962 4.352 4.352 0 0 0-4.328 3.962h1.388a2.97 2.97 0 0 1 2.94-2.583z",
    fill: "#ff7557",
    "data-name": "Path 1011",
    transform: "translate(-403.853 401.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    d: "M413.572-383.567a2.971 2.971 0 0 1-2.793-1.973h-1.435a4.352 4.352 0 0 0 4.228 3.353 4.352 4.352 0 0 0 4.228-3.353h-1.435a2.97 2.97 0 0 1-2.793 1.973z",
    fill: "#ff7557",
    "data-name": "Path 1012",
    transform: "translate(-404.043 390.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    d: "M431.239-389.54h-1.388a2.953 2.953 0 0 1 .028.385 2.945 2.945 0 0 1-.175.995h1.435a4.341 4.341 0 0 0 .119-.995 4.084 4.084 0 0 0-.019-.385z",
    fill: "#ff7557",
    "data-name": "Path 1013",
    transform: "translate(-417.382 393.502)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    d: "M410.377-389.155a2.953 2.953 0 0 1 .028-.385h-1.388a4.45 4.45 0 0 0-.019.385 4.32 4.32 0 0 0 .119.995h1.435a2.953 2.953 0 0 1-.175-.995z",
    fill: "#ff7557",
    "data-name": "Path 1014",
    transform: "translate(-403.816 393.502)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123",
    transform: "translate(9.906 34.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    d: "M459.438-321.387a2.971 2.971 0 0 0 2.884-2.278h-5.767a2.97 2.97 0 0 0 2.883 2.278z",
    fill: "none",
    "data-name": "Path 1015",
    transform: "translate(-434.974 328.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    d: "M459.438-334.272a2.971 2.971 0 0 0-2.883 2.278h5.767a2.971 2.971 0 0 0-2.884-2.278z",
    fill: "none",
    "data-name": "Path 1016",
    transform: "translate(-434.974 335.651)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    d: "M414.148-327.665h-19.487a.689.689 0 0 0-.69.69.69.69 0 0 0 .69.69h19.487a4.368 4.368 0 0 1-.06-.69 4.37 4.37 0 0 1 .06-.69z",
    fill: "#ff7557",
    "data-name": "Path 1017",
    transform: "translate(-393.971 331.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    d: "M500.19-327.665h-22.84a4.334 4.334 0 0 1 .06.69 4.333 4.333 0 0 1-.06.69h22.84a.69.69 0 0 0 .69-.69.69.69 0 0 0-.69-.69z",
    fill: "#ff7557",
    "data-name": "Path 1018",
    transform: "translate(-448.599 331.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    d: "M456.771-336.893a2.971 2.971 0 0 1 2.884 2.278h1.4a4.35 4.35 0 0 0-4.287-3.658 4.351 4.351 0 0 0-4.287 3.658h1.4a2.971 2.971 0 0 1 2.89-2.278z",
    fill: "#ff7557",
    "data-name": "Path 1019",
    transform: "translate(-432.307 338.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    d: "M456.771-321.387a2.97 2.97 0 0 1-2.883-2.278h-1.4a4.351 4.351 0 0 0 4.287 3.658 4.35 4.35 0 0 0 4.287-3.658h-1.4a2.971 2.971 0 0 1-2.891 2.278z",
    fill: "#ff7557",
    "data-name": "Path 1020",
    transform: "translate(-432.307 328.702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    d: "M453.69-326.975a2.934 2.934 0 0 1 .084-.69h-1.4a4.37 4.37 0 0 0-.06.69 4.368 4.368 0 0 0 .06.69h1.4a2.936 2.936 0 0 1-.084-.69z",
    fill: "#ff7557",
    "data-name": "Path 1021",
    transform: "translate(-432.194 331.323)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    d: "M474.683-327.665h-1.4a2.953 2.953 0 0 1 .084.69 2.955 2.955 0 0 1-.084.69h1.4a4.333 4.333 0 0 0 .06-.69 4.334 4.334 0 0 0-.06-.69z",
    fill: "#ff7557",
    "data-name": "Path 1022",
    transform: "translate(-445.932 331.323)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124",
    transform: "translate(3.48 2.931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_104",
    cx: 0.983,
    cy: 0.983,
    r: 0.983,
    fill: "#ff7557",
    "data-name": "Ellipse 104"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(9.773 2.931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    cx: 0.983,
    cy: 0.983,
    r: 0.983,
    fill: "#ff7557",
    "data-name": "Ellipse 105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126",
    transform: "translate(6.626 2.931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_106",
    cx: 0.983,
    cy: 0.983,
    r: 0.983,
    fill: "#ff7557",
    "data-name": "Ellipse 106"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElegant);
export default __webpack_public_path__ + "static/media/Elegant.54ff54ba5842c9126ffb884c3fe949ae.svg";
export { ForwardRef as ReactComponent };